import { useCallback, useEffect, useState } from "react"
import { useSelector } from "react-redux";
import api, { operation } from "../services/axios";
import { StoreState } from "../store";

interface SaveContactData {
    nomeTitular: string 
    numeroDocumentoTitular: string 
    compe?: string 
    agencia?: string
    numeroConta?: string 
    tipoConta?: string 
    email: string 
    telefone?: string 
    ispb?: string 
    cnpj_cpf: string
    contactId: string | number | undefined
}

export const useContacts = () => {
    const { cnpj_cpf } = useSelector((state: StoreState) => state.auth.user)
    const [contacts, setContacts] = useState<any[]>([])
    const [contactsParsed, setContactsParsed] = useState<any[]>([])

     const getContacts = useCallback(async () => {
        operation.attempt(async (currentAttempt) => {
            try {
                const { data } = await api.get(`/contatos/${cnpj_cpf}`)
                const contactsParsed = data.map((contact: any) => ({
                    value: contact,
                    label: contact.nomeTitular
                }))
                setContacts(data)
                setContactsParsed(contactsParsed)
            } catch (error) {
                // tentar denovo
            }
        });
    }, [cnpj_cpf])

    useEffect(() => {
        getContacts()
    }, [getContacts])

    async function saveContact (contact: SaveContactData) {
        // fazer tratamento
        const dataContactParsed: SaveContactData = {
            cnpj_cpf,
            nomeTitular: contact.nomeTitular,
            numeroDocumentoTitular: contact.numeroDocumentoTitular.replace(/\D/g, ''),
            email: contact.email,
            agencia: contact.agencia || '',
            compe: contact.compe || '',
            ispb: contact.ispb || '',
            numeroConta: contact.numeroConta || '',
            tipoConta: contact.tipoConta || '',
            telefone: contact?.telefone?.replace(/\D/g, '') || '',
            contactId: contact.contactId,
        }
       const { data } = await api.post('/contato', dataContactParsed)
       return data
    }

    return {
        contacts,
        setContacts,
        contactsParsed, 
        setContactsParsed,
        saveContact
    }
}